import { SVGProps } from '@components/Icon/types';

export const Visible = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9998 3.01996C8.17307 3.01996 4.6837 5.27599 2.29951 9.02379C1.76066 9.86824 1.51485 10.9529 1.51485 11.995C1.51485 13.0369 1.76057 14.1213 2.29922 14.9657C4.68341 18.7137 8.17291 20.97 11.9998 20.97C15.8266 20.97 19.316 18.7139 21.7002 14.9661C22.239 14.1217 22.4848 13.0371 22.4848 11.995C22.4848 10.953 22.2391 9.86864 21.7005 9.02425C19.3163 5.27617 15.8268 3.01996 11.9998 3.01996ZM3.48048 9.77566C5.67628 6.32375 8.76678 4.41996 11.9998 4.41996C15.2329 4.41996 18.3234 6.32375 20.5192 9.77566L20.5198 9.77658C20.8807 10.3421 21.0848 11.1473 21.0848 11.995C21.0848 12.8427 20.8807 13.6479 20.5198 14.2133L20.5192 14.2143C18.3234 17.6662 15.2329 19.57 11.9998 19.57C8.76678 19.57 5.67628 17.6662 3.48048 14.2143L3.47989 14.2133C3.11895 13.6479 2.91485 12.8427 2.91485 11.995C2.91485 11.1473 3.11895 10.3421 3.47989 9.77658L3.48048 9.77566ZM9.11992 11.9999C9.11992 10.4065 10.4065 9.11991 11.9999 9.11991C13.5933 9.11991 14.8799 10.4065 14.8799 11.9999C14.8799 13.5933 13.5933 14.8799 11.9999 14.8799C10.4065 14.8799 9.11992 13.5933 9.11992 11.9999ZM11.9999 7.71991C9.63333 7.71991 7.71992 9.63331 7.71992 11.9999C7.71992 14.3665 9.63333 16.2799 11.9999 16.2799C14.3665 16.2799 16.2799 14.3665 16.2799 11.9999C16.2799 9.63331 14.3665 7.71991 11.9999 7.71991Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'visible';
